import { dataFetch } from '@lib/ggj-utils'

export default {
  // 身份证图片上传
  facePlusUpload(params) {
    return dataFetch('/identity-auth/api/idcard/auth/checkIdcard', params, {
      'method': 'post', headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  // 身份信息提交
  identityCommit(params) {
    return dataFetch('/identity-auth/api/idcard/auth/uploadIdcard', params, {
      'method': 'post', headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  // 获取实名信息
  identity(params) {
		return dataFetch('/identity-auth/api/idcard/auth/getMaskedRealNameInfo', params, {
      'method': 'get'
    })
  },
  // 获取人脸识别token fece++
  facePlusToken(params) {
		return dataFetch('/identity-auth/api/user/auth/getAuthtokenWithALY', params, {
      'method': 'post', headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  // 人脸识别完成
  finish(params) {
    return dataFetch('/identity-auth/api/user/auth/queryRealAuthDetail', params, {
      'method': 'post', headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  // face++人脸识别回调
  facepluscb(params) {
    return dataFetch('/identity-auth/api/user/auth/callback', params, {
      'method': 'post', headers: {
        'Content-Type': 'application/json'
      }
    })
  }
}
